import { WaiterQuantities, WaiterTables } from '@infra/deal';

export interface UTM {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  application?: string;
  partner?: string;
  gclid?: string;
  fbclid?: string;
  ttclid?: string;
  redirect_by?: string;
  ifood_merchant_id?: string;
  indicado_aid?: string;
  terceirizado?: string;
  freemium?: string;
  admin_v2?: string;
  ref?: string;
  redirect?: string;
  waiter_quantity?: WaiterQuantities | string;
  waiter_tables?: WaiterTables | string;
  ab_test_mkt?: string;
  msclkid?: string;
  epik?: string;
  _epik?: string;
  click_id?: string;
  bid?: string;
  has_waiter?: string;
  establishment_type?: string;
  functionality_type?: string;
}

export const UTM_MODEL_KEYS: (keyof UTM)[] = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'application',
  'partner',
  'gclid',
  'fbclid',
  'ttclid',
  'redirect_by',
  'ifood_merchant_id',
  'indicado_aid',
  'terceirizado',
  'freemium',
  'admin_v2',
  'ref',
  'redirect',
  'waiter_quantity',
  'waiter_tables',
  'ab_test_mkt',
  'msclkid',
  'bid',
  'click_id',
  'has_waiter',
  'establishment_type',
  'functionality_type',
];
